let enabled = false;

export function enableRB2B() {
  if (!window.reb2b || enabled) return;
  enabled = true;
  window.reb2b.push(["config", { enabled: true }]);
  console.log("[RB2B] ENABLED");
}

export function disableRB2B() {
  if (!window.reb2b || !enabled) { console.log("[RB2B] already disabled"); return; }
  enabled = false;
  window.reb2b.push(["config", { enabled: false }]);
  console.log("[RB2B] DISABLED");
}
